import React, { Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import routes from './routes';
import Protected from './ProtectedRoute';
import ErrorBoundary from '../Components/ErrorBoundary';
import lazyWithRetry from '../Utils/lazyWithRetry';

interface RouteInterface {
  key: string;
  path: string;
  isPrivate: boolean;
  component: React.LazyExoticComponent<React.ComponentType<any>>;
}
const Login = lazyWithRetry(() => import('../Pages/Authentication'));
const Users = lazyWithRetry(() => import('../Pages/Users'));
const Dashboard = lazyWithRetry(() => import('../Pages/Statistique'));
const Pubs = lazyWithRetry(() => import('../Pages/Publicitaire'));
const Abonnement = lazyWithRetry(() => import('../Pages/Abonnement'));
const Contact = lazyWithRetry(() => import('../Pages/Contact'));
const Report = lazyWithRetry(() => import('../Pages/Report'));
const Madagascar = lazyWithRetry(() => import('../Pages/MadagascarMap'));
const PaymentSuccess = lazyWithRetry(() => import('../Pages/PaymentSuccess'));
const PaymentCanceled = lazyWithRetry(() => import('../Pages/PaymentCanceled'));

const routesCo: RouteInterface[] = [
  {
    key: 'Dashboard',
    path: routes.DASHBOARD,
    component: Dashboard,
    isPrivate: true,
  },
  {
    key: 'Login',
    path: routes.LOGIN,
    component: Login,
    isPrivate: false,
  },
  {
    key: 'Users',
    path: routes.USERS,
    component: Users,
    isPrivate: true,
  },
  {
    key: 'Pubs',
    path: routes.PUBS,
    component: Pubs,
    isPrivate: true,
  },
  {
    key: 'Abonnement',
    path: routes.ABONNEMENT,
    component: Abonnement,
    isPrivate: true,
  },
  {
    key: 'Contact',
    path: routes.CONTACT,
    component: Contact,
    isPrivate: true,
  },
  {
    key: 'Report',
    path: routes.RAPPORT,
    component: Report,
    isPrivate: true,
  },
  {
    key: 'MadagascarMap',
    path: routes.MADAGASCAR_MAP,
    component: Madagascar,
    isPrivate: false,
  },
  {
    key: 'PaymentSuccess',
    path: routes.PAYMENT_SUCCESS,
    component: PaymentSuccess,
    isPrivate: false,
  },
  {
    key: 'PaymentCanceled',
    path: routes.PAYMENT_CANCELED,
    component: PaymentCanceled,
    isPrivate: false,
  },
];

const PageLoader = () => (
  <Box display="flex" alignItems="center" justifyContent="center" minHeight="100vh">
    <CircularProgress />
  </Box>
);

const Router = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            {routesCo?.map((item) => {
              const { key, path, isPrivate, component: Component } = item;
              return (
                <Route
                  key={key}
                  path={path}
                  element={
                    isPrivate ? (
                      <Protected>
                        <Component />
                      </Protected>
                    ) : (
                      <Component />
                    )
                  }
                />
              );
            })}
            <Route path="*" element={<div>Not Found</div>} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Router;
